import React, { createContext, useContext, useState, useEffect } from 'react';
import { Field } from '../models/Field'; // Import your model

const LocationContext = createContext();

export const useLocation = () => useContext(LocationContext);

export const LocationProvider = ({ children }) => {
  const [location, setLocation] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!navigator.geolocation) {
      setError('Geolocation is not supported by your browser');
      setLoading(false);
      return;
    }

    // Get position
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const userLoc = {
          lat: position.coords.latitude,
          long: position.coords.longitude
        };
        
        // 1. Update React State (triggers re-renders)
        setLocation(userLoc);
        
        // 2. Update Field Class Static Property (keeps your model logic working!)
        Field.userLocation = userLoc;
        
        setLoading(false);
      },
      (err) => {
        let errorMessage = 'Unable to retrieve your location';
        
        switch(err.code) {
          case err.PERMISSION_DENIED:
            errorMessage = 'Location access was denied. Some features may be limited.';
            break;
          case err.POSITION_UNAVAILABLE:
            errorMessage = 'Location information is unavailable.';
            break;
          case err.TIMEOUT:
            errorMessage = 'Location request timed out.';
            break;
          default:
            errorMessage = 'An unknown error occurred while retrieving location.';
            break;
        }
        
        setError(errorMessage);
        setLoading(false);
        console.warn("Location Error: ", err);
      }
    );
  }, []);

  return (
    <LocationContext.Provider value={{ location, error, loading }}>
      {children}
    </LocationContext.Provider>
  );
};